import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import {Button, Collapse, Grid, Typography} from "@mui/material"
import {Box} from "@mui/system"
import _ from "lodash"
import {FC, useState} from "react"
import {EventProgresBar} from "../../../components/Routes/EventProgresBar"
import {ClimbigEventType, ClimbingEvent, getDifficultyFor} from "../../../models/ClimbingEvent"
import {isDone, UserClimbingEvent} from "../../../models/UserClimbingEvent"
import {useTranslation} from "react-i18next";

type Props = {
  event: ClimbingEvent,
  userEvent: UserClimbingEvent
}

export const UserEventStatisticComponent: FC<Props> = ({event, userEvent}) => {
  const {t} = useTranslation()
  const [collapsed, setCollapsed] = useState(true);
  var checkedRoutes = event.routes.filter(r => isDone(userEvent.climbingRoutes.find(cr => cr.id === r.id)?.status))
  var dificulties = getDifficultyFor(event.type, event.showGrade)

  var doneInGrade = _(checkedRoutes).groupBy(r => r.dificulty).map((r, d) => ({
    dificulty: d,
    points: _.sumBy(r, "points")
  })).value();

  var maxInGrade = _(event.routes).groupBy(r => r.dificulty).map((r, d) => ({
    dificulty: d,
    points: _.sumBy(r, "points")
  })).value();

  return (
    <Box display="flex" alignItems="center" flexDirection="column">
      {event.separateZonePoint || event.separateFlashPoint?
        <Typography align="center" variant="h6"
                    m={2}>{t('event.sumOfTops', {sumOfTops: userEvent?.sumOfPoints})} {t(event.separateZonePoint? 'event.sumOfZones': 'event.sumOfFlashes', {sumOfZones: userEvent?.sumOfZones})}</Typography>
        : <Typography align="center" variant="h6"
                      m={2}>{t('event.sumOfPoints', {sumOfPoints: userEvent?.sumOfPoints})}</Typography>
      }


      {event.type === ClimbigEventType.BOULDER && <>
          <Button color="secondary" sx={{mb: 2}} onClick={() => setCollapsed(!collapsed)}>Statystyki {collapsed ?
            <ArrowDropDownIcon/> : <ArrowDropUpIcon/>}</Button>
          <Collapse in={!collapsed}>
              <Grid container spacing={2} mb={2} alignItems="center"
                    justifyContent="center">
                {maxInGrade.map(r => (
                  <Grid item xs={6} sm={6} md={4} lg={3} key={`difficulty-progress-bar-${r.dificulty}`}>
                    <EventProgresBar max={r.points}
                                     done={doneInGrade.find(d => d.dificulty === r.dificulty)?.points || 0}
                                     label={r.dificulty}
                                     colour={dificulties.find(d => d.difficulty === r.dificulty)?.colour}/>
                  </Grid>
                ))}
              </Grid>
          </Collapse>
      </>}
    </Box>
  )
}